import request from "@/utils/request";

// 新建文章
export function createArticle(data) {
  return request({
    url: "/newMall/healthArticle/createHealthArticle",
    method: "post",
    data
  });
}

// 修改文章
export function updateArticle(data) {
  return request({
    url: "/newMall/healthArticle/updateHealthArticle",
    method: "post",
    data
  });
}

// 文章列表
export function getHealthArticleList(params) {
  return request({
    url: "/newMall/healthArticle/getHealthArticleList",
    method: "get",
    params
  });
}

// 文章详情
export function getHealthArticleDetail(params) {
  return request({
    url: "/newMall/healthArticle/getHealthArticle",
    method: "get",
    params
  });
}

// 批量上线科普文章
export function enableHealthArticle(data) {
  return request({
    url: "/newMall/healthArticle/batchOnlineHealthArticle",
    method: "post",
    data
  });
}

// 批量下线科普文章
export function disableHealthArticle(data) {
  return request({
    url: "/newMall/healthArticle/batchOfflineHealthArticle",
    method: "post",
    data
  });
}

// 批量删除科普文章
export function deleteHealthArticle(data) {
  return request({
    url: "/newMall/healthArticle/batchDeleteHealthArticle",
    method: "post",
    data
  });
}

// 查询健康科普活动列表
export function getHealthActivityList(params) {
  return request({
    url: "/newMall/healthActivity/getHealthActivityList",
    method: "get",
    params
  });
}

// 更新健康科普活动
export function updateHealthActivity(data) {
  return request({
    url: "/newMall/healthActivity/updateHealthActivity",
    method: "post",
    data
  });
}

// 查询健康科普活动
export function getHealthActivity(params) {
  return request({
    url: "/newMall/healthActivity/getHealthActivity",
    method: "get",
    params
  });
}

// 新增健康科普活动
export function createHealthActivity(data) {
  return request({
    url: "/newMall/healthActivity/createHealthActivity",
    method: "post",
    data
  });
}

// 批量上线健康科普活动
export function batchOnlineHealthActivity(data) {
  return request({
    url: "/newMall/healthActivity/batchOnlineHealthActivity",
    method: "post",
    data
  });
}

// 批量下线健康科普活动
export function batchOfflineHealthActivity(data) {
  return request({
    url: "/newMall/healthActivity/batchOfflineHealthActivity",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/shop/article.js